import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {instructionPathZod} from './schemas';

const toolName = 'delete-instruction' as const;

const argumentZod = z.object({
  path: instructionPathZod.describe(
    'The instruction file or folder path to delete, for example rules/brand.md, brand-guidelines/SKILL.md, or brand-guidelines/references. Deleting a skill folder or subfolder removes all descendants.'
  ),
});

export const deleteInstructionManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Delete instruction',
  llmTool: {
    name: toolName,
    description:
      'Deletes one agent instruction (rule, skill, companion file, or subfolder) by path in the current site. Idempotent. Deleting a skill folder or subfolder cascades to all descendants.',
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.AGENT_INSTRUCTIONS,
  permission: [{resource: 'SiteAgentInstructions', action: 'manage'}],
  confirmBeforeExecuting: true,
});

export type DeleteInstructionArgumentType = z.infer<typeof argumentZod>;
